"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var LineChartSplitSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M4,4 L4,7.293 L5.5,8.793 L7,7.29289322 L9,9.293 L14.1464466,4.14644661 C14.3417088,3.95118446 14.6582912,3.95118446 14.8535534,4.14644661 C15.0271197,4.32001296 15.0464049,4.58943736 14.9114088,4.7843055 L14.8535534,4.85355339 L9,10.7071068 L7,8.707 L6.207,9.5 L9,12.293 L14.1464466,7.14644661 C14.320013,6.97288026 14.5894374,6.95359511 14.7843055,7.08859116 L14.8535534,7.14644661 C15.0271197,7.32001296 15.0464049,7.58943736 14.9114088,7.7843055 L14.8535534,7.85355339 L9,13.7071068 L5.5,10.207 L4,11.706 L4,14 L15,14 L15,15 L3,15 L3,4 L4,4 Z M4,8.707 L4,10.292 L4.793,9.5 L4,8.707 Z" })));
};
LineChartSplitSmall.displayName = 'LineChartSplitSmall';
exports.default = LineChartSplitSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=LineChartSplitSmall.js.map